import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { IconButton } from "@mui/material";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";

const Download = (props) => {
  const [menu, setMenu] = useState(false);
  const [bottom, setBottom] = useState(false);

  const first = (isDropDown) => {
    return [
      <div key="1-1" className={`icon-container-lg ${!isDropDown && 'bottom'}`}>
        <img alt="file_direct" src="/images/file_direct.svg" height={18} width={18}/>
      </div>,
      <div key="1-2" className="me-3 flex-grow-1">
        <div className="font-size-15 font-weight-bold">Шууд татах</div>
        <div className="font-size-13 text-grey">
          Уг татах сонголт нь таны бичиж оруулсан өгөгдөлтэй нь {isDropDown ? <br /> : null}
          хамт татах сонголт.
        </div>
      </div>,
      <IconButton key="1-3" className="mx-1">
        <img alt="download_red" src="/images/download_red.svg" height={16} />
      </IconButton>,
    ];
  };

  const second = (isDropDown) => {
    return [
      <div key="2-1" className={`icon-container-lg ${!isDropDown && 'bottom'}`}>
        <img alt="file_direct" src="/images/file_template.svg" height={16} width={18}/>
      </div>,
      <div key="2-2" className="me-3 flex-grow-1">
        <div className="font-size-15 font-weight-bold">
          Бэлэн загвараар татах
        </div>
        <div className="font-size-13 text-grey">
          Уг татах сонголт огт өгөгдөл оруулаагүй хоосон файл {isDropDown ? <br /> : null}
          татагдана.
        </div>
      </div>,
      <IconButton key="2-3" className="mx-1">
        <img alt="download_red" src="/images/download_red.svg" height={16} />
      </IconButton>,
    ];
  };

  return (
    <React.Fragment>
      <Dropdown
        className="d-none d-sm-inline-flex"
        isOpen={menu}
        toggle={() => setMenu(!menu)}
      >
        <DropdownToggle className="d-flex align-items-center pointer" tag="div">
          <img alt="download" src="/images/download.svg" height={14} />
          <div className="download-btn text-secondary mx-2">Файл татах</div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu py-0">
          <DropdownItem tag="div" className="download-dropdown pe-3 py-3">{first(true)}</DropdownItem>
          <hr className="my-0" />
          <DropdownItem tag="div" className="download-dropdown pe-3 py-3">{second(true)}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <div
        onClick={() => setBottom(!bottom)}
        className="d-inline-flex d-sm-none align-items-center pointer"
      >
        <div className="download-btn text-secondary mx-2">Файл татах</div>
        <img alt="arrow" src="/images/arrow_down_blue.svg" height={6} />
      </div>
      <BottomSheet
        open={bottom}
        onDismiss={() => setBottom(false)}
        snapPoints={({ minHeight }) => minHeight}
      >
        <div className="download-dropdown pe-3 py-3">
          {first(false)}
        </div>
        <hr className="my-0" />
        <div className="download-dropdown pe-3 py-3 mb-3">
          {second(false)}
        </div>
      </BottomSheet>
    </React.Fragment>
  );
};

export default Download;
